import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * The version actually running on the server.
 *
 * Read from the API rather than baked into the bundle at build time: a stale
 * cached bundle would otherwise report the version it was built with, and that
 * is precisely the situation where you need the truth ("am I looking at the
 * deploy I just made?"). Fetching it means the number always describes the
 * server answering the page.
 *
 * Fails silently to null — a missing version badge must never break a screen.
 */
export default function useAppVersion() {
  const [info, setInfo] = useState({ version: null, startedAt: null });

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/version`)
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (!cancelled && data && data.version) {
          setInfo({ version: data.version, startedAt: data.startedAt || null });
        }
      })
      .catch(() => { /* badge simply stays hidden */ });
    return () => { cancelled = true; };
  }, []);

  return info;
}
